"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const localsync_1 = require("./localsync");
exports.localsyncShim = (channel, publisher, subscriber) => {
    console.warn("Use of the default export is deprecated. Use the `localsync` named export instead.");
    if (publisher !== undefined && subscriber !== undefined) {
        return localsync_1.localsync({ channel })(publisher, subscriber);
    }
    if (publisher === undefined || subscriber === undefined) {
        throw new Error("Publisher and subscriber should be defined together.");
    }
    return localsync_1.localsync({ channel });
};
//# sourceMappingURL=localsyncShim.js.map